import * as z from "zod/v4";

const shipStationApiCarrierSchema = z.object({
  carrierId: z.string(),
  carrierCode: z.string().nullish(),
  name: z.string().nullish(),
  nickname: z.string().nullish(),
  accountNumber: z.string().nullish(),
});

export const getShipStationApiIntegration = {
  name: "getShipStationApiIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    integrationId: z.string().nullish(),
    packagesSyncedAt: z.string().nullish(),
    tagsSyncedAt: z.string().nullish(),
    learningSyncedAt: z.string().nullish(),
    usersSyncedAt: z.string().nullish(),
    locationsSyncedAt: z.string().nullish(),
    carriersSyncedAt: z.string().nullish(),
    carriers: z.array(shipStationApiCarrierSchema).nullish(),
    authError: z.boolean().nullish(),
  }),
};
